<template>
  <TarjetaDatos titulo="Vehículo Contrario" tipo="naranja">
    <Campo2L :valor="contrario.matricula" etiqueta="Matrícula" />
    <Campo2L :valor="contrario.modelo" etiqueta="Modelo" />
    <Campo2L :valor="contrario.compania" etiqueta="Compañía" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    contrario: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
